export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtDokladSM';
export const NAME = 'Doklad';
export const DOKLAD_OSTATNI = 'DokladOstatni';
export const ATTACHMENT_FILES = 'AttachmentFiles';
export const NONGENUINE_ATTACHMENT_FILES = 'NonGenuineAttachmentFiles';
export const ADVANCEPAY = 'AdvancePay';

export enum DOKLAD_TYP {
	REF_DOC = 'RD',
	QUICK_ESTIMATE = 'QE',
	SALE_QUOTE = 'SQ',
	DAN_PRODEJ = 'B',
	DD1_DILNA = 'ZD',
	VRATKA_ND_GD = 'R',
	GARANCE = 'G',
	DOBROPIS = 'D',
	ZALOHOVA_FAKTURA = 'Q',
	INTERNI = 'I',
	DAN_DOKLAD = 'W',
	ZKRAC_DAN_DOKLAD = 'Z',
	DD_POL_DOB = 'DX',
	STORNO_DD = 'E',
	STORNO_ZAL = 'QS',
	DD_KOSM = '1',
	PREVODKA_ND = 'Y',
	STORNO_1DD = 'ZE',
	DOBROP_1DD = 'ZF',
	STORNO_INT_DOK = 'EI',
	DD_VRUBOPIS = 'DP',
	DD_CAST_DOBROPIS = 'DC',
	PRIJEMKA_ND_NDPOHYB = 'P',
	SKLAD_DOBROPIS_NDPOHYB = 'O',
	SKLAD_VYDEJKA_ND = 'V',
	PROFORMA_INT_DOK_NV = 'FU',
	STORNO_1DD_NV = 'ZP',
	STORNO_ZALOHY_NV = 'LS',
	PROFORMA_NV = 'U',
	DOBROPIS_NV = 'T',
	STORNO_INT_NV = 'KI',
	DD_VRUBOPIS_NV = 'TP',
	DD_CAST_VRUBOPIS_NV = 'TC',
	DOBROPIS_1DD_NV = 'ZR',
	DD1_NV = 'ZN',
	STAORNO_DD_NV = 'K',
	INT_DOKL_NV = 'F',
	DD_NV = 'S',
	ZALOHOVA_FAKTURA_NV = 'L',
	ZALOHOVA_FAKTURA_OV = 'JL',
	STORNO_DD_OV = 'JK',
	DOBROPIS_1DD_OV = 'ZT',
	DD_VRUBOPIS_OV = 'JP',
	DD_CAST_DOBROPIS_OV = 'JC',
	DD1_OV = 'ZO',
	PROFORMA_OV = 'JU',
	STORNO_ZALOHY_OV = 'JS',
	DOBROPIS_OV = 'JT',
	DD_OV = 'J',
	STORNO_1DD_OV = 'ZS',
	POKLADNI_VKLAD_VYBER = 'VV',
	PRIJMOVY = 'OP',
	VYDEJOVY = 'OV',
	NABIDKA_NEZAVAZNA = 'A',
	PROFORMA_PSEUDO = 'X',
	PREDAV_PROT_SM = 'C',
	STORNO_VYDEJKA_ND_NV = 'MX',
	VYDEJKA_NV_KONS_DOBR = 'MO',
	STORNO_VUDEJ_NV_KS = 'MR',
	PRIJ_NV_K_DOBR = 'HR',
	PRIJEMKA_NV_KS = 'NO',
	PRIJEMKA_DOBROPIS_NV = 'H',
	PRIJEMKA_NV = 'N',
	VYDEJKA_NV = 'M',
	PIJEMKA_OV_DOBROP = 'JH',
	PIJEMKA_OV_KOMISE = 'JO',
	VYDEJKA_OV_KOMISE = 'JG',
	VYDEJKA_OV = 'JM',
	PIJEMKA_OV = 'JN',
	OBJEDNAVKA_NV = 'ON',
	CUSTOMER_SATISFACTION = 'CS',
	PARTS_SALES_ORDER = 'PSO',
	PARTS_SALES_CREDIT_MEMO = 'PSCM'
}
